
import { onMounted, onUnmounted, ref } from '@vue/composition-api';
import SharedState from '@/data/SharedState';

/* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
export default function useCookieBot(context: any, cookieTypeConsent: string, acceptFn?: () => void) {

  const hasCookiebotOnPage = () => {
    return SharedState.getInstance(context).contextInfo.needsCookieConsent;
  };
  const hasConsent = ref(hasCookiebotOnPage() === false);
  const consentInfoReady = ref(hasCookiebotOnPage() === false)

  const hasCookiebotConsent = (): boolean => {
    //@ts-ignore
    return window !== undefined &&
      //@ts-ignore
      window.Cookiebot !== undefined &&
      //@ts-ignore
      window.Cookiebot.consent !== undefined &&
      //@ts-ignore
      window.Cookiebot.consent[cookieTypeConsent] !== undefined &&
      //@ts-ignore
      window.Cookiebot.consent[cookieTypeConsent] === true;
  }

  const checkConsent = () => {
    if(!hasCookiebotOnPage()) return true;
    return hasCookiebotConsent();
  }

  const textsForVideos = () => {

    return {
      text1: SharedState.getText(context, 'cookie.renew.video.message1'),
      text2: SharedState.getText(context, 'cookie.renew.video.message2'),
      text3: SharedState.getText(context, 'cookie.renew.video.message3'),
    };
  };


  const setConsent = (consentValue: boolean) => {
    hasConsent.value = consentValue;

    // @ts-ignore
    const miVideoPlayer = window ? window.VideoPlayer : undefined;

    if(miVideoPlayer) {
      if(consentValue) {
        miVideoPlayer.Collection.acceptAnalytics();
      }
    }
  };

  const onAcceptCookies = () => {
    if(hasCookiebotConsent() && hasConsent.value !== true && acceptFn) {
      setConsent(true);
      acceptFn();
    }
  };

  const onConsentReady = () => {
    consentInfoReady.value = true;
    setConsent(checkConsent());
  };

  onMounted(() => {
    if(hasCookiebotOnPage()) {
      window.addEventListener('CookiebotOnAccept', onAcceptCookies);
      window.addEventListener('CookiebotOnConsentReady', onConsentReady);
      window.addEventListener('CookiebotOnDecline', onConsentReady);
    }
    setConsent(checkConsent());

  });
  onUnmounted(() => {
    if(hasCookiebotOnPage()) {
      window.removeEventListener('CookiebotOnAccept', onAcceptCookies);
      window.removeEventListener('CookiebotOnConsentReady', onConsentReady);
      window.removeEventListener('CookiebotOnDecline', onConsentReady);
    }
  });

  return {
    hasCookiebotOnPage,
    textsForVideos,
    hasConsent,
    consentInfoReady
  };
}
